import { Component, Input, OnChanges } from '@angular/core';
import { MenuService } from '../mega-menu.service.component';
import { StateService } from '@uirouter/angular';
import { UserService } from '../../../core/services/core.user.service';

@Component({
    selector: 'project-heading-dropdown',
    template: require('./project-heading-dropdown.component.html'),
  })
  export class ProjectHeadingDropdownComponent implements OnChanges {
    @Input() projectMenu: any;
    anyTrackersAvailable: boolean;
    isProjectMember: boolean;
    menuGlyph: string;
    isTrackerAdmin: boolean;
    available: any;
    showPlanTrack: boolean;
    hasScm: boolean;
    showDevOps: boolean;
    showKnowledge: boolean;
    showTracker: boolean;
    sortedTrackers: any;
    glyphClass: any;
    hasSessionUser: boolean;
  
    constructor(private menuService: MenuService, private stateService: StateService, private userService: UserService) {}

    private init() {
      this.hasSessionUser = this.userService.hasUser();
      this.anyTrackersAvailable = this.menuService.anyTrackersAvailable(this.projectMenu);
      this.isProjectMember = this.menuService.isProjectMember(this.projectMenu);
      this.menuGlyph = this.menuService.getMenuGlyph(this.projectMenu, this.stateService);
      this.glyphClass = this.menuGlyph + ' glyph-md';
      this.isTrackerAdmin = !!this.projectMenu && (this.projectMenu.admin || this.projectMenu.tracker >= 99);
      this.available = this.menuService.getAllAvailable(this.projectMenu);
  
      this.showPlanTrack =
        this.isProjectMember && (this.available.tracker || this.available.frs);
  
      this.hasScm =
        this.available.scmgit || this.available.scmsvn || this.available.scmcvs;
  
      this.showDevOps = this.hasScm || this.available.build;
  
      this.showKnowledge =
        this.available.wiki || this.available.docman || this.available.forum;
  
      this.showTracker =
        this.menuService.moduleAvailable(this.projectMenu, 'tracker') &&
        (this.available.tracker || this.isTrackerAdmin);

      const trackers = (this.projectMenu && this.projectMenu.trackers) || [];
      this.sortedTrackers = trackers.slice().sort((a, b) =>
        String(a.trackerName == null ? '' : a.trackerName).localeCompare(String(b.trackerName == null ? '' : b.trackerName))
      );
    }

    ngOnInit() {
      this.init();
    }

    ngOnChanges(): void {
      this.init();
    }

    trackByFn(index: number, item: any): number {
      return item.id; // Assuming 'id' is the unique identifier property
    }
  }
  